import { temAcesso } from '@/shared/auth/temAcesso'

const Servicos = () => import('./Servicos.vue')
const ServicoDetalhar = () => import('./ServicoDetalhar.vue')

export default {
    path: 'servicos',
    name: 'Gescon_Uabs_Servicos',
    component: {
        render(c) {
            return c('router-view')
        }
    },
    beforeEnter: (to, from, next) => {
        if (temAcesso('GESCON-UABS-SERV-00')) {
            next()
        }
    },
    children: [
        {
            path: '',
            name: 'Gescon_Uabs_Servicos_Listagem',
            component: Servicos,
            beforeEnter: (to, from, next) => {
                if (temAcesso('GESCON-UABS-SERV-00')) {
                    next()
                }
            }
        },
        {
            path: 'detalhar/:id',
            name: 'Gescon_Uabs_Servicos_Detalhar',
            component: ServicoDetalhar,
            beforeEnter: (to, from, next) => {
                if (temAcesso('GESCON-UABS-SERV-00')) {
                    next()
                }
            }
        }
    ]
}
